const STATIC_TERMS_MAP = {
    customer_name: '[CUSTOMER NAME]',
    seller_name: '[SELLER NAME]',
    seller_email: '[SELLER EMAIL]',
    seller_country: '[SELLER COUNTRY]',
    beat_title: '[BEAT NAME]',
    sound_pack_title: '[SOUND PACK NAME]',
    service_title: '[SERVICE NAME]',
    service_number_revisions: '[SERVICE NUMBER OF REVISIONS]',
}

export function parseAgreementTags(text, customMap = {}) {
    if (!text) {
        return text;
    }

    // Replace static terms with the values from the map
    text = Object.entries({
        ...STATIC_TERMS_MAP,
        ...customMap,
    }).reduce((acc, [key, value]) => {
        return acc.replace(new RegExp(`{{\\s*${key}\\s*}}`, 'g'), value);
    }, text);

    // Replace dynamic terms
    return text.replace(/{{ order_date }}/g, new Date().toLocaleDateString());
}
